import React from "react";
import { Instagram, Star } from "lucide-react";
import { track } from "@/lib/analytics";
import { getLinks } from "@/lib/links";
import TikTokIcon from "./TikTokIcon";
import ReviewsShowcase from "./ReviewsShowcase";

const btn = "inline-flex items-center gap-2 rounded-full bg-[#0C0C0C] text-[#FFC20E] font-display font-extrabold uppercase tracking-wide text-base px-6 py-3 min-h-[48px] hover:scale-[1.03] transition-transform duration-200";
const h = "font-display font-black uppercase display-tight text-4xl sm:text-5xl text-[#0C0C0C]";

export default function SocialReviewBlock({ settings }) {
  const l = getLinks(settings);
  const hasSocial = l.instagram || l.tiktok;
  if (!hasSocial && !l.review) return null;
  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 relative z-10 mt-16 pt-10 border-t-4 border-[#0C0C0C] grid md:grid-cols-2 gap-10" data-testid="social-review-block">
      {hasSocial && (
        <div data-testid="social-block">
          <h3 className={h}>SE VUOI SAPERLO PRIMA, SEGUICI.</h3>
          <p className="font-semibold text-lg text-[#0C0C0C] mt-3">Nuovi morsi, drop, backstage e novità UNGRIP.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            {l.instagram && (
              <a href={l.instagram} target="_blank" rel="noopener noreferrer" onClick={() => track("instagram_click", {})} className={btn} data-testid="social-instagram-cta">
                <Instagram size={18} /> INSTAGRAM →
              </a>
            )}
            {l.tiktok && (
              <a href={l.tiktok} target="_blank" rel="noopener noreferrer" onClick={() => track("tiktok_click", {})} className={btn} data-testid="social-tiktok-cta">
                <TikTokIcon size={18} /> TIKTOK →
              </a>
            )}
          </div>
        </div>
      )}
      {l.review && (
        <div className="min-w-0" data-testid="review-block">
          <h3 className={h}>TI HA PRESO UNGRIP? LASCIA IL SEGNO.</h3>
          <p className="font-semibold text-lg text-[#0C0C0C] mt-3">Se il morso ti è rimasto in testa, faccelo sapere.</p>
          <a href={l.review} target="_blank" rel="noopener noreferrer" onClick={() => track("google_review_click", {})} className={`${btn} mt-6`} data-testid="google-review-cta">
            <Star size={18} /> RECENSISCI SU GOOGLE
          </a>
          <ReviewsShowcase reviews={settings?.reviews} />
        </div>
      )}
    </div>
  );
}
